import { IDictionaryEventTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryEventTypeSelectOption';
import { IKnmErknmFormEvent } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';

const getEventTypeDictVersionId = (type?: IDictionaryEventTypeSelectOption) => type?.value?.dictVersionId;

export const recalculateActEventCopyNumbers = (innerEvents: IKnmErknmFormEvent[]): IKnmErknmFormEvent[] => {
  const typeTotals = new Map<string, number>();

  innerEvents.forEach(event => {
    const typeId = getEventTypeDictVersionId(event.type);

    if (typeId) {
      typeTotals.set(typeId, (typeTotals.get(typeId) || 0) + 1);
    }
  });

  const typeOccurrences = new Map<string, number>();

  return innerEvents.map(event => {
    const typeId = getEventTypeDictVersionId(event.type);

    if (!typeId || (typeTotals.get(typeId) || 0) <= 1) {
      return { ...event, eventCopyNumber: undefined };
    }

    const currentNumber = (typeOccurrences.get(typeId) || 0) + 1;

    typeOccurrences.set(typeId, currentNumber);

    return { ...event, eventCopyNumber: String(currentNumber) };
  });
};

export const applyActEventCopyNumbersToForm = (
  formRef: { change: (field: string, value?: unknown) => void } | undefined,
  actEventsFieldName: string,
  innerEvents: IKnmErknmFormEvent[],
) => {
  if (!formRef) {
    return;
  }

  const recalculated = recalculateActEventCopyNumbers(innerEvents);

  recalculated.forEach((event, index) => {
    const newCopyNumber = event.eventCopyNumber;
    const oldCopyNumber = innerEvents[index]?.eventCopyNumber;

    if (newCopyNumber !== oldCopyNumber) {
      formRef.change(`${actEventsFieldName}[${index}].eventCopyNumber`, newCopyNumber);
    }
  });
};

export const getActEventTypeDisplayLabel = (label: string, eventCopyNumber?: string): string => {
  if (eventCopyNumber) {
    return `${label} №${eventCopyNumber}`;
  }

  return label;
};
